import { RootState } from "../../utils/types"

export const AllNotificationsSelector = (state: RootState) =>
  state.notifications.notifications

export const notificationStatusSelector = (state: RootState) => state.notifications